export default function CloudArrowUp() {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6 13H4.5C3.57174 13 2.6815 12.6313 2.02513 11.9749C1.36875 11.3185 1 10.4283 1 9.5C1 8.57174 1.36875 7.6815 2.02513 7.02513C2.6815 6.36875 3.57174 6 4.5 6C4.79283 5.99989 5.08458 6.03557 5.36875 6.10625'
        stroke='#908E96'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5 8C5 7.20774 5.18827 6.42682 5.54928 5.7216C5.9103 5.01637 6.43373 4.40703 7.07645 3.94379C7.71916 3.48055 8.46276 3.17667 9.24596 3.05719C10.0292 2.93771 10.8295 3.00605 11.5811 3.25658C12.3327 3.50712 13.0141 3.93267 13.5689 4.49817C14.1238 5.06368 14.5363 5.75294 14.7726 6.50916C15.0088 7.26539 15.0619 8.06692 14.9276 8.84771C14.7933 9.6285 14.4754 10.3662 14 11'
        stroke='#908E96'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.38135 10.1187L9.5001 8L11.6188 10.1187'
        stroke='#908E96'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.5 13V8'
        stroke='#908E96'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
